import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ActionsType } from './types'
import offerPdf from '../../../../features/opportunities/assets/offer.pdf?url'

export const PreviewOffer = ({ offer, ...props }: ActionsType) => {
  const { t } = useLocales()

  // PDF files can be displayed directly in iframe
  const pdfUrl = `${offerPdf}#toolbar=0`

  return (
    <Modal
      width={900}
      title={
        offer
          ? `${t('generic.preview')} - ${offer.offer_number}`
          : t('generic.preview')
      }
      cancelButtonProps={{ hidden: true }}
      okText={t('buttons.close') || t('buttons.cancel')}
      onOk={props.onCancel}
      {...props}
    >
      <iframe
        title="offer-preview"
        width="100%"
        height="820px"
        loading="lazy"
        src={pdfUrl}
        allowFullScreen
      />
    </Modal>
  )
}
